/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CitationReviewResponse } from './CitationReviewResponse';
import type { MappingReviewResult } from './MappingReviewResult';
import type { RestoredMapping } from './RestoredMapping';
export type AIReviewBatchItemResult = {
  security_id: number;
  /**
   * A failed item changed nothing; errors says why.
   */
  status: AIReviewBatchItemResult.status;
  /**
   * Requested field names the action settled (reopened, for reopen).
   */
  settled_fields: Array<string>;
  /**
   * Reopen only: fields whose value went back to its pre-AI baseline. A reopened field missing here kept a manual edit.
   */
  restored_fields: Array<string>;
  /**
   * Every named citation, read after the writes.
   */
  citations: Array<CitationReviewResponse>;
  /**
   * Every named mapping, read after the writes.
   */
  mappings: Array<MappingReviewResult>;
  /**
   * Mapping rows an accept replaced; the page drops them from the grid.
   */
  retired_ids: Array<number>;
  /**
   * Mapping rows a decline or reopen brought back; the page adds them to the grid.
   */
  restored: Array<RestoredMapping>;
  errors: Array<string>;
};
export namespace AIReviewBatchItemResult {
  /**
   * A failed item changed nothing; errors says why.
   */
  export enum status {
    SETTLED = 'settled',
    FAILED = 'failed',
  }
}

